import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function Trash({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ').trim()}
      color={color}
      fontSize={size}
      style={style}
      viewBox='0 0 16 16'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.66667 0C10.403 0 11 0.596954 11 1.33333V2H12.6667C13.403 2 14 2.59695 14 3.33333V4C14 4.62128 13.5751 5.14331 13 5.29133V14.6667C13 15.403 12.403 16 11.6667 16H4.33333C3.59695 16 3 15.403 3 14.6667V5.29133C2.42492 5.14331 2 4.62128 2 4V3.33333C2 2.59695 2.59695 2 3.33333 2H5V1.33333C5 0.596954 5.59695 0 6.33333 0H9.66667ZM10 1.33333V2H6V1.33333L6.00677 1.26616C6.03785 1.11426 6.17225 1 6.33333 1H9.66667L9.73384 1.00677C9.88574 1.03785 10 1.17225 10 1.33333ZM13 4C13 4.18409 12.8508 4.33333 12.6667 4.33333H3.33333C3.14924 4.33333 3 4.18409 3 4V3.33333C3 3.14924 3.14924 3 3.33333 3H5H11H12.6667C12.8508 3 13 3.14924 13 3.33333V4ZM12 5.334H4V14.6667C4 14.8277 4.11426 14.9621 4.26616 14.9932L4.33333 15H11.6667C11.8277 15 11.9621 14.8857 11.9932 14.7338L12 14.6667V5.334ZM8.49194 6.65087C8.44961 6.41762 8.24546 6.24074 8 6.24074C7.72386 6.24074 7.5 6.4646 7.5 6.74074V13.2593L7.50806 13.3491C7.55039 13.5824 7.75454 13.7593 8 13.7593C8.27614 13.7593 8.5 13.5354 8.5 13.2593V6.74074L8.49194 6.65087ZM10 6.24074C10.2455 6.24074 10.4496 6.41762 10.4919 6.65087L10.5 6.74074V13.2593C10.5 13.5354 10.2761 13.7593 10 13.7593C9.75454 13.7593 9.55039 13.5824 9.50806 13.3491L9.5 13.2593V6.74074C9.5 6.4646 9.72386 6.24074 10 6.24074ZM6.49194 6.65087C6.44961 6.41762 6.24546 6.24074 6 6.24074C5.72386 6.24074 5.5 6.4646 5.5 6.74074V13.2593L5.50806 13.3491C5.55039 13.5824 5.75454 13.7593 6 13.7593C6.27614 13.7593 6.5 13.5354 6.5 13.2593V6.74074L6.49194 6.65087Z'
      />
    </svg>
  );
}
